var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button",attrs:{"ripple":false},on:{"click":_vm.generatePdf}},[_vm._v(" Salvar Código em PDF "),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-file-download-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }